var classnames = {exports: {}};

export { classnames as __module };
